import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import "../../css/ResetPassword.module.css"; // اضافه کردن استایل
import BASE_URL from "../../config/config";
import Captcha from "./Captcha"; 

const ResetPassword = () => {
  const { resetToken } = useParams(); // دریافت توکن از URL
  const [password, setPassword] = useState(""); // ذخیره رمز عبور وارد شده
  const [confirmPassword, setConfirmPassword] = useState(""); // ذخیره تأیید رمز عبور
  const [message, setMessage] = useState(null); // پیام موفقیت یا خطا
  const [isLoading, setIsLoading] = useState(false); // وضعیت ارسال درخواست
  const passwordValidation =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  const [csrfToken, setCsrfToken] = useState(""); 
  const [captchaVerified, setCaptchaVerified] = useState(false);

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(`${BASE_URL}/csrf-token`, {
          credentials: "include", // ارسال کوکی‌ها به همراه درخواست
        });
        const data = await response.json();

        if (!data.csrfToken) {
          console.error("CSRF token not received or invalid!");
        } else {
          setCsrfToken(data.csrfToken);
        }
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCsrfToken();
  }, []);

  // هندل کردن ارسال فرم
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaVerified) {
      setMessage("لطفاً کد امنیتی را تأیید کنید.");
      return;
    }

    if (!passwordValidation.test(password)) {
      setMessage(
        "رمز عبور باید حداقل 8 کاراکتر، شامل حروف بزرگ و کوچک، اعداد و علامت‌ها باشد."
      );
      setIsLoading(false);
      document.getElementById("password").focus(); // فوکوس بر روی فیلد رمز عبور
      return;
    }

    // چک کردن مطابقت رمز عبور و تأیید رمز عبور
    if (password !== confirmPassword) {
      return setMessage("رمز عبور و تأیید آن مطابقت ندارد!");
    }

    setIsLoading(true); // نمایش لودینگ
    setMessage(null); // تنظیم مجدد پیام

    try {
      const response = await fetch(`${BASE_URL}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "CSRF-Token": csrfToken, // ارسال توکن CSRF در هدر
        },
        body: JSON.stringify({
          resetToken, // ارسال توکن با رمز عبور
          newPassword: password,
        }),
        credentials: "include",
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(
          `رمز عبور با موفقیت تنظیم شد! اکنون می‌توانید <a href="/login" style="color: blue; text-decoration: underline;">وارد شوید</a>.`
        );
      } else {
        setMessage(
          data.message || "مشکلی پیش‌آمده است. لطفاً دوباره تلاش کنید."
        );
      }
    } catch (error) {
      setMessage("خطایی رخ داده است. لطفاً بعداً تلاش کنید.");
    } finally {
      setIsLoading(false); // پایان وضعیت ارسال
    }
  };

  return (
    <div className="reset-password-container">
      <div className="reset-password-box">
        <h1>بازیابی رمز عبور</h1>
        {message && (
          <p
            className={
              message.includes("موفقیت") ? "success-message" : "error-message"
            }
            dangerouslySetInnerHTML={{ __html: message }}
          ></p>
        )}
        <form onSubmit={handleSubmit}>
          {/* کامپوننت CAPTCHA داخلی */}
          <Captcha 
            onVerify={(isVerified) => setCaptchaVerified(isVerified)}
            onExpire={() => setCaptchaVerified(false)}
            timeout={120000}
            regenerateOnError={true}
          />
          
          <div className="form-group">
            <label htmlFor="password">رمز عبور جدید</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">تأیید رمز عبور جدید</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={isLoading || !captchaVerified}>
            {isLoading ? "در حال تنظیم رمز عبور..." : "تنظیم رمز عبور"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;